// extracted by mini-css-extract-plugin
export var overviewSection = "overview-section-module--overview-section--3SH5Z";
export var overviewItem = "overview-section-module--overview-item--1GK2H";